import { SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME, SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED, } from '@/utils/constants/seminar/seminarInformation/adjustSchedule';
import { SEMINAR_INFORMATION_APPLICATION_PROCESS_EMAIL, SEMINAR_INFORMATION_APPLICATION_PROCESS_URL, } from '@/utils/constants/seminar/seminarInformation/applicationProcess';
import { seminarOneRequest } from '@/utils/router/links';
/**
 * 申し込みリンクに表示するテキストを返す
 * @param params
 */
export const getRequestLinkText = (params) => {
    const { adjustSchedule, applicationDeadline, applicationProcess, isApplicationDeadlineExceeded, } = params;
    switch (adjustSchedule) {
        // 随時開催の場合
        case SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME.value: {
            switch (applicationProcess) {
                case SEMINAR_INFORMATION_APPLICATION_PROCESS_URL.value: {
                    // 外部ページから申し込む場合
                    return '詳細ページへ';
                }
                case SEMINAR_INFORMATION_APPLICATION_PROCESS_EMAIL.value: {
                    // 自社内から申し込む場合
                    return '開催を相談する';
                }
                default: {
                    return '';
                }
            }
        }
        // 日程が設定されている場合
        case SEMINAR_INFORMATION_ADJUST_SCHEDULE_FIXED.value: {
            // 期限が切れているか
            const isExceeded = applicationDeadline && isApplicationDeadlineExceeded;
            switch (applicationProcess) {
                case SEMINAR_INFORMATION_APPLICATION_PROCESS_URL.value: {
                    // 外部ページから申し込む場合
                    return isExceeded ? '再実施リクエスト' : '詳細ページへ';
                }
                case SEMINAR_INFORMATION_APPLICATION_PROCESS_EMAIL.value: {
                    // 自社内から申し込む場合
                    return isExceeded ? '再実施リクエスト' : '申し込む';
                }
                default: {
                    return '';
                }
            }
        }
        default: {
            return '';
        }
    }
};
/**
 * 申し込みリンク使用不可時に表示するテキストを返す
 * @param params
 */
export const getDisableLinkTooltipText = (params) => {
    const { isPreview, isProfessional } = params;
    if (isPreview) {
        return 'プレビュー時はセミナーへの申し込みはできません';
    }
    if (isProfessional) {
        return 'コンサルタントはセミナーへの申し込みはできません';
    }
    return '';
};
/**
 * セミナー申込方法に応じた詳細ページへのリンクを取得する
 * @param params
 */
export const getRequestLink = (params) => {
    const { applicationProcess, applicationUrl = '', id } = params;
    // 外部サイト経由で申し込む場合は外部URL、そうでない場合はProffit内リンクで対応する
    return applicationProcess ===
        SEMINAR_INFORMATION_APPLICATION_PROCESS_URL.value
        ? applicationUrl
        : seminarOneRequest(id);
};
